// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restricted-money {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stats {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: space-between;
}

.text-align-right {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-restricted-money/restricted-money.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,8BAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".restricted-money{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.stats  {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: space-between;\r\n    justify-content: space-between;\r\n}\r\n\r\n.text-align-right {\r\n    text-align: right;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
